import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectAppConfigValueByKey } from './app-config.selectors';

export const selectBffBaseUrl = selectAppConfigValueByKey('bff');

export const selectFhirBaseUrl = selectAppConfigValueByKey('fhirBaseUrl');
export const selectDevelopmentMode =
  selectAppConfigValueByKey('developmentMode');
export const selectNamespacesOnboardingProvider1001 = selectAppConfigValueByKey(
  'namespacesOnboardingProvider1001',
);
export const selectNamespacesOnboardingProvider1002 = selectAppConfigValueByKey(
  'namespacesOnboardingProvider1002',
);
export const selectNamespacesOnboardingProvider1003 = selectAppConfigValueByKey(
  'namespacesOnboardingProvider1003',
);
export const selectNamespacesOnboardingProvider1004 = selectAppConfigValueByKey(
  'namespacesOnboardingProvider1004',
);
export const selectNamespacesOnboardingProvider1005 = selectAppConfigValueByKey(
  'namespacesOnboardingProvider1005',
);
export const selectNamespacesOnboardingProvider1006 = selectAppConfigValueByKey(
  'namespacesOnboardingProvider1006',
);
export const selectNamespacesOnboardingProvider1007 = selectAppConfigValueByKey(
  'namespacesOnboardingProvider1007',
);
export const selectAuditPollInterval =
  selectAppConfigValueByKey('auditPollInterval');
export const selectConfig = selectAppConfigValueByKey('config');
export const selectPatientRootId = selectAppConfigValueByKey('patientRootId');
export const selectAccountPatientNamespace = selectAppConfigValueByKey(
  'accountPatientNamespace',
);
export const selectMessaging = selectAppConfigValueByKey('messaging');
export const selectPermissionManagerUrl = selectAppConfigValueByKey(
  'permission-manager-uri',
);
export const selectIsShowMessenger = pipe(
  selectAppConfigValueByKey('showMessenger'),
  map((value) => value === 'true'),
);
export const selectIsUseTestAttribute = pipe(
  selectAppConfigValueByKey('IS_USE_TEST_ATTRIBUTES'),
  map((value) => value === 'true'),
);

export const selectRepresentationsConfig =
  selectAppConfigValueByKey('representations');
